"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _blocks = require("@bueno/blocks");

var _Site = require("./Site.styles");

class Site extends _react.Component {
  shouldComponentUpdate(prevProps) {
    return this.props.isSelected !== prevProps.isSelected;
  }

  render() {
    const {
      label,
      isSelected,
      handleClick,
      noMatch,
      disabled
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Site.$Site, {
      type: "button",
      disabled: disabled,
      noMatch: noMatch,
      title: label
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "Site-label",
      onClick: handleClick
    }, label), /*#__PURE__*/_react.default.createElement(_blocks.Checkbox, {
      onChange: handleClick,
      checked: isSelected,
      disabled: disabled
    }));
  }

}

(0, _defineProperty2.default)(Site, "propTypes", {
  noMatch: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  isSelected: _propTypes.default.bool.isRequired,
  handleClick: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool.isRequired
});
(0, _defineProperty2.default)(Site, "defaultProps", {
  noMatch: false
});
var _default = Site;
exports.default = _default;
module.exports = exports.default;